import React, { Component } from 'react';
import styled from 'styled-components';
import CarouselSlidePicker from "./CarouselSlidePicker";
import VehicleSpecs from "./VehicleSpecs";
import ConfirmationPopup from "./ConfirmationPopup";
import currencyHelper from '../../helpers/CurrencyHelper';
import Defaulf_Img from './vehicleimagenotavailable1.png';
import Down_Arrow from './down-arrow.png';
import { apiGetLoanMaster, apiCheckPromo, apiGetBanner } from "../../apis/calculator";
import { withRouter } from "react-router";
import arrow from './arrow.svg'
import ReactPixel from 'react-facebook-pixel';
import AlertBox from '../AlertBox';

class Configurator extends Component {
    constructor() {
        super();
        this.state = {
            showPopup: false,
            yearvalue1: '',
            monthvalue: '',
            myDate: '',
            myOption: 'wyne',

            consent: false,
            name: '',
            mobile: '',
            email: '',
            sales: '',
            trade: '',
            popupTxt: '',

            nameError: false,
            mobileError: false,
            emailError: false,

            nameErrorMsg: '',
            mobileErrorMsg: '',
            emailErrorMsg: '',

            formMode: false,
            loanMaster: {},

            promo: '',
            promoCodeId: '',
            promoDesc: '',
            promoPriceDesc: '',
            promoPrice: '',
            tenure: '7',
            promoValid: false,
            loanEdited: false,
            loanAmount: '',
            loanError: '',

            maxLoan: '',
            minLoan: '',
            // initial: true,
            
            // initialColor: true,
            // initialPre: true,

            inputFormat: true,

            initial: true,
            price: '',
            netPrice: '',
            monthlyPayment: '',
            loanPercent: '',
            loanPercentOMV: '',
            interestRate: '',

            alertMsg: '',
            prod: false

        };
    }

    componentDidMount = () => {

        if (window.location.href.includes("online-sales.mazda.com.sg")) {
            ReactPixel.init('273792070524054');
            ReactPixel.pageView();

            this.setState({
                prod: true
            })
          }

        apiGetLoanMaster().then((res) => {
            if (res.data) {
                this.setState({
                    loanMaster: res.data,
                    minLoan: res.data.minimumLoanAmount
                })
            }
            else {
                this.setState({
                    showPopup: true,
                    popupTxt: 'An error has been encountered. Please retry later.'
                })
            }
        }).catch((e) => {
            this.setState({
                showPopup: true,
                popupTxt: 'An error has been encountered. Please retry later.'
            })
            console.log(e)
        });

    }

    componentDidUpdate = (prevProps, prevState, snapshot) => {

    const { form, entities, ui } = this.props;
    const pkg = form.package && entities.packages[form.package];
    const prevPkg = prevProps.form.package && prevProps.entities.packages[prevProps.form.package];
    const state = this.state;
    let colorList = ui.colors.map(i => entities.colors[i]);

    if (!this.state.loanMaster.omvQualifierAmount) {
        return;
    }

    if (state.initial) { // First Update

        this.getBanner(this.props.match.params.isNew, pkg.modelClassLabel);

        let url = this.props.location.pathname; // Check params
        let array = url.split('/')

        if (array.length === 9) { // If params exist

            this.setState({
                initialParams: true
            })

            let params = {
                carModelId: array[4],
                color: array[5],
                loanPercent: array[6],
                tenure: array[7],
                msrp: array[8]
            }

            colorList.forEach((i) => {   // Preferred Color 
                if (i.color === params.color) {
                    if (i.trimList !== null && i.trimList.length) {
                        this.props.onFieldChange('color', params.carModelId + '/' + params.color)
                    }
                }
            })

            const loanMaster = state.loanMaster,
            netPrice = params.msrp - state.promoPrice;

            let loanAmount, interestRate, loanPercentOMV, monthlyPayment;

            if (pkg.omvAmount > loanMaster.omvQualifierAmount) {
                loanPercentOMV = loanMaster.aboveOMVLoanPercent;
            }
            else {
                loanPercentOMV = loanMaster.belowOMVLoanPercent;
            }

            loanAmount = netPrice * ( params.loanPercent / 100);

            let loanAmountOMV = netPrice * ( loanPercentOMV / 100);

            if ((params.tenure >= (loanMaster.qualifierTenure)) && parseInt( (loanAmount.toString().replace(',', ''))) >= (loanMaster.qualifierLoanAmount) ) {
                interestRate = loanMaster.discountInterestRate
            }
            else {
                interestRate = loanMaster.normalInterestRate
            }

            monthlyPayment = ((parseInt( (loanAmount.toString().replace(',', ''))) + (parseInt( (loanAmount.toString().replace(',', ''))) * params.tenure * (interestRate / 100 ))) / (params.tenure * 12));

            loanAmount = loanAmount.toFixed(0);
            loanAmountOMV = loanAmountOMV.toFixed(0);

            this.setState({
                netPrice,
                price: params.msrp,
                tenure: params.tenure,
                loanPercentOMV,
                loanPercent: params.loanPercent,
                loanAmount,
                monthlyPayment,
                interestRate,
                maxLoan: loanAmountOMV
            }, () => {
                this.toggleInput(true);
                this.checkLoan();
            })



        }
        else {
            colorList.forEach((i) => {   // Preferred Color 
                if (i.color === pkg.preferredColorCode) {
                    if (i.trimList !== null && i.trimList.length) {
                        this.props.onFieldChange('color', pkg.carModelId + '/' + pkg.preferredColorCode)
                    }
                }
            })

            const loanMaster = state.loanMaster,
            netPrice = pkg.msrp - state.promoPrice;

            let loanAmount, interestRate, loanPercentOMV, monthlyPayment;

            if (pkg.omvAmount > loanMaster.omvQualifierAmount) {
                loanPercentOMV = loanMaster.aboveOMVLoanPercent;
            }
            else {
                loanPercentOMV = loanMaster.belowOMVLoanPercent;
            }

            loanAmount = netPrice * ( loanPercentOMV / 100);

            if ((state.tenure >= (loanMaster.qualifierTenure)) && parseInt( (loanAmount.toString().replace(',', ''))) >= (loanMaster.qualifierLoanAmount) ) {
                interestRate = loanMaster.discountInterestRate
            }
            else {
                interestRate = loanMaster.normalInterestRate
            }

            monthlyPayment = ((parseInt( (loanAmount.toString().replace(',', ''))) + (parseInt( (loanAmount.toString().replace(',', ''))) * state.tenure * (interestRate / 100 ))) / (state.tenure * 12));

            loanAmount = loanAmount.toFixed(0);

            this.setState({
                netPrice,
                price: pkg.msrp,
                loanPercentOMV,
                loanPercent: loanPercentOMV,
                loanAmount,
                monthlyPayment,
                interestRate,
                maxLoan: loanAmount
            }, () => {
                this.toggleInput(true);
                this.checkLoan();
            })
        }


        this.setState({
            initial: false // No more first update
        })
    }

    if (pkg.id !== prevPkg.id) // Color is chosen
    {

        const loanMaster = state.loanMaster,
        netPrice = pkg.msrp - state.promoPrice;

        let loanAmount, interestRate, loanPercentOMV, monthlyPayment, loanAmountOMV;

        if (pkg.omvAmount > loanMaster.omvQualifierAmount) {
            loanPercentOMV = loanMaster.aboveOMVLoanPercent;
        }
        else {
            loanPercentOMV = loanMaster.belowOMVLoanPercent;
        }

        loanAmount = netPrice * ( state.loanPercent / 100);
        loanAmountOMV = netPrice * (loanPercentOMV / 100);

        if ((state.tenure >= (loanMaster.qualifierTenure)) && parseInt( (loanAmount.toString().replace(',', ''))) >= (loanMaster.qualifierLoanAmount) ) {
            interestRate = loanMaster.discountInterestRate
        }
        else {
            interestRate = loanMaster.normalInterestRate
        }


        monthlyPayment = ((parseInt( (loanAmount.toString().replace(',', ''))) + (parseInt( (loanAmount.toString().replace(',', ''))) * state.tenure * (interestRate / 100 ))) / (state.tenure * 12));
   
        loanAmount = loanAmount.toFixed(0)
        loanAmountOMV = loanAmountOMV.toFixed(0);

        setTimeout(() => {
            this.setState({
                netPrice,
                price: pkg.msrp,
                loanPercentOMV,
                loanAmount,
                monthlyPayment,
                interestRate,
                maxLoan: loanAmountOMV
            }, () => {
                this.toggleInput(true);
                this.checkLoan();
            })
        }, 50)

        
    }
    // else {
    //     this.setState({
    //         price: pkg.msrp
    //     })
    // }
}

    checkLoan = () => {
        // let val = this.state.netPrice * ( this.state.loanPercent / 100);

        let val = parseInt( (this.state.loanAmount.toString().replace(',', '')))

        if (val) {
            val = val.toFixed(0)
        }

        if (+val > this.state.maxLoan) {
            this.setState({
                loanAmount: this.state.maxLoan
            }, () => {
                this.toggleInput(true);
                this.calculateInterestRate();
                this.calculateNetPrice();
            })
        }
        else if (+val < this.state.minLoan || !val) {
            this.setState({
                loanAmount: this.state.minLoan
            }, () => {
                this.toggleInput(true);
                this.calculateInterestRate();
                this.calculateNetPrice();
            })
        }
        else {
            this.setState({
                loanAmount: val
            }, (() => {
                this.toggleInput(true);
                this.calculateInterestRate();
                this.calculateNetPrice();
            }))
        }
    }


    handleCheck = () => {
        const val = this.state.consent;
        this.setState({
            consent: !val
        })
    }

    toggleInput = (bool) => {

        let loanAmount;

        if (!this.state.loanAmount) {return}

        if (!isNaN(loanAmount)) {
            loanAmount = loanAmount.toFixed(0);
        }

        if (bool) {
            loanAmount = this.state.loanAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        } else {
            let string = this.state.loanAmount.toString().replace(',', '');
            loanAmount = parseInt(string)
        }

        this.setState({
            loanAmount
        })
        
    }

    handlePopup = () => {
        const val = this.state.showPopup;
        this.setState({
            showPopup: !val
        })
    }

    handleClick = (e, pdf) => {
        e.preventDefault();
        window.open(pdf)
    }

    handleForm = (
        monthlyPayment,
        interestRate,
        omvLoanPercent,
        netPrice,
        techSpec1,
        techSpec2,
        techSpec3,
        techSpec4,
        colorPaletteCode,
        colorName,
        stock,
        pdf,
        src,
        modelClassLabel,
        carModelName,
        id,
        carModelId,
        color,
        loanPercentDisplay) => {
        let data = {
            monthlyPayment,
            interestRate,
            omvLoanPercent,
            netPrice,
            promoCodeId: this.state.promoCodeId,
            promoCode: this.state.promo,
            tenure: this.state.tenure,
            loanAmount: this.state.loanAmount,
            techSpec1,
            techSpec2,
            techSpec3,
            techSpec4,
            colorPaletteCode,
            colorName,
            stock,
            pdf,
            src,
            modelClassLabel,
            carModelName,
            id,
            loanPercent: this.state.loanPercent
        }
        localStorage.setItem('data', JSON.stringify(data));

        let variantId = this.props.match.params.variantId;

        let preData = {
            carModelId,
            loanPercent: loanPercentDisplay,
            tenure: this.state.tenure,
            color
        };

        localStorage.setItem(variantId, JSON.stringify(preData));

        
            window.scroll({
            top: 0, 
            left: 0, 
            behavior: 'smooth'
          });

        let params = this.props.match.params;

        this.props.history.push('/customer_info/' + params.variantId + "/" + params.isNew + "/" + carModelId + "/" + color + "/" + loanPercentDisplay + "/" + this.state.tenure + "/" + this.state.price )
    }

    handleChange = (e) => {
        let name = e.target.name,
            val = e.target.value

        if (name === "promo") {
            if (val) {
                val = val.toUpperCase();
            }
        }

        if (name === "loanAmount") {

            if (isNaN(Number(val))) {
                return
            }

            if (val) {
                val = parseInt(val).toFixed(0)
            }
        }
        this.setState ({
            [name]: val
        }, () => {
            if (name === "tenure") {
                this.calculateInterestRate();
                this.calculateNetPrice();
            }  
            if (name === "loanAmount") {
                this.calculateNetPrice();
                this.calculateInterestRate();
            }
        })
    }

    calculateNetPrice = () => {
        const state = this.state;

        let netPrice = state.price - state.promoPrice;

        this.setState({
            netPrice
        }, () => {
            this.calculateLoanPercent();
        })
    }

    calculateMonthlyPayment = () => {
        const state = this.state;
        let monthlyPayment = ((parseInt( (state.loanAmount.toString().replace(',', ''))) + (parseInt( (state.loanAmount.toString().replace(',', ''))) * state.tenure * (state.interestRate / 100 ))) / (state.tenure * 12));
        this.setState({
            monthlyPayment
        })
    }

    calculateLoanPercent = () => {
        const state = this.state;
        let loanPercent = ((parseInt( (state.loanAmount.toString().replace(',', ''))) / state.netPrice) * 100);

        this.setState({
            loanPercent
        })
    }

    calculateInterestRate = () => {
        const state = this.state;
        let interestRate;

        if ((state.tenure >= (state.loanMaster.qualifierTenure)) && parseInt( (state.loanAmount.toString().replace(',', ''))) >= (state.loanMaster.qualifierLoanAmount) ) {
            interestRate = state.loanMaster.discountInterestRate
        }
        else {
            interestRate = state.loanMaster.normalInterestRate
        }

        this.setState({
            interestRate
        }, () => {
            this.calculateMonthlyPayment();
        })
    }

    handlePromo = () => {
        let val = this.state.promo

        const { form, entities } = this.props;

        const pkg = form.package && entities.packages[form.package];
        const isNew = this.props.match.params.isNew

        apiCheckPromo(val, pkg.modelClassId, isNew).then((res) => {
            if (res) {
                let promoPrice, promoDesc, promoPriceDesc;

                if (res.isTopup) {
                    promoPrice = 0 - res.price
                }
                else {
                    promoPrice = res.price
                }

                if (res.promoType === 1 && promoPrice !== 0) {
                    let sign = "- "
                    if (res.isTopup) {
                        sign = "+ "
                    }
                    promoPriceDesc = sign + "$" + res.price
                }
                else {
                    promoPriceDesc = ""
                }

                promoDesc = res.displayPromoDescription;

                this.setState({
                    promoCodeId: res.id,
                    promoPrice,
                    promoDesc,
                    promoPriceDesc,
                    promoValid: true,
                    loanEdited: false
                }, () => {
                    this.calculatePostPromo();
                });
            }
            else {
                this.setState({
                    promoCodeId: '',
                    promoPrice: '',
                    promoDesc: '',
                    promoPriceDesc: '',
                    promoValid: false
                }, () => {
                    this.calculatePostPromo();
                });
            }
        }).catch((e) => {
            this.setState({
                showPopup: true,
                popupTxt: 'An error has been encountered. Please retry later.',
                promoCodeId: '',
                promoPrice: '',
                promoDesc: '',
                promoPriceDesc: '',
                promoValid: false
            })
            console.log(e)
        });
    }

    calculatePostPromo = () => {
        const state = this.state;

        let netPrice = state.price - this.state.promoPrice;

        this.setState({
            netPrice
        })

        let loanAmount = netPrice * ( state.loanPercent / 100);

        loanAmount = loanAmount.toFixed(0);


        let interestRate;

        if ((state.tenure >= (state.loanMaster.qualifierTenure)) && parseInt( (loanAmount.toString().replace(',', ''))) >= (state.loanMaster.qualifierLoanAmount) ) {
            interestRate = state.loanMaster.discountInterestRate
        }
        else {
            interestRate = state.loanMaster.normalInterestRate
        }

        this.setState({
            interestRate
        }, () => {
            const state = this.state;
            let monthlyPayment = ((parseInt( (loanAmount.toString().replace(',', ''))) + (parseInt( (loanAmount.toString().replace(',', ''))) * state.tenure * (state.interestRate / 100 ))) / (state.tenure * 12));
            this.setState({
                monthlyPayment
            })
        })

        this.setState({
            loanAmount
        }, () => {
            this.toggleInput(true);
            this.checkLoan();
        })
    }

    blurLoan = (e) => {
        this.checkLoan();
        e.target.blur();
    }

    getBanner = (isNew, modelCode) => {
        Promise.all([apiGetBanner(isNew, modelCode)]).then(([r])=>{
          if (r) {
            this.setState({
              alertMsg: r
            });
          }
          else {
            this.setState({
              alertMsg: ''
            })
          }
        }).catch((e)=>{
          if(!this.props.errorHandler.handleError(e)) throw e;
        });
      }



    render() {
        const { className, form, entities, ui, onFieldChange } = this.props;
        let trimList = ui.trims.map(i => entities.trims[i]);
        let colorList = ui.colors.map(i => entities.colors[i]);

        let stock = trimList[0].stock;

        const pkg = form.package && entities.packages[form.package];

        let src;
        if (`${pkg && pkg.coverImage}`.split("/")[`${pkg && pkg.coverImage}`.split("/").length - 1] == 'vehicleimagenotavailable1.PNG') {
            src = Defaulf_Img
        } else {
            src = pkg && pkg.coverImage
        }

        const fields = pkg && [
            {
                label: 'FUEL CONSUMPTION',
                value: pkg.techSpec1
            },
            {
                label: 'CO2 EMISSION',
                value: pkg.techSpec2
            },
            {
                label: 'VES BANDING',
                value: pkg.techSpec3
            },
            {
                label: 'COE CATEGORY',
                value: pkg.techSpec4
            }
        ]

        const state = this.state;

       
        return <div className={className}>
            {
                this.state.alertMsg ? <AlertBox alertTxt={this.state.alertMsg} /> : ''
            }
            {
                this.state.prod ? <img border="0" style={{width: 0, height: 0, position: "absolute"}} src="https://r.turn.com/r/beacon?b2=8ncjy9uACyk_tO9BMjlMQnH9nrn7F73eWwXh42RxuBmzNPlUFo4chDo95bs8J6m4Ljxcxfldi3sv3NF9i_llJg&cid=" /> : ''
            }
            <div className='wrapper'>
                <div className="nav-container">
                    <div className="nav-wrap active">
                        <div className="nav-no">1</div>
                        <div className="nav-txt">Financial calculator</div>
                    </div>
                    <div className="nav-wrap">
                        <div className="nav-no">2</div>
                        <div className="nav-txt">Customer Information</div>
                    </div>
                    <div className="nav-wrap">
                        <div className="nav-no">3</div>
                        <div className="nav-txt">Payment</div>
                    </div>
                </div>

                <div className="leftSide">
                    <div className='topArtical'>


                    <div className="carTitle-wrap">
                        <span className="carTitle-class">{pkg.modelClassLabel}</span> <span className="carTitle-label">{pkg.carModelName}</span> <br />
                        {
                            this.props.match.params.isNew === "false" ?
                            <div className="carTitle-demo">Demo unit</div> : ''
                        }
                    </div>


                        {
                            form.carModel && form.color && form.trim && form.package &&
                            <div>
                                <img className={'configurator__model_image'} src={src} alt="" />
                                <div className="carImg-info">Car image is for illustration purpose only. Specifications may vary.</div>
                            </div>
                        }
                                {
                                    form.carModel && <CarouselSlidePicker value={form.color}
                                        onChange={value => onFieldChange('color', value)}
                                        valueDescription={form.color ? `Colour: ${entities.colors[form.color].colorName} (${entities.colors[form.color].color})` : ''}
                                        options={colorList.map(item => ({
                                            id: item.id,
                                            src: item.colorImage,
                                            colorPaletteCode: item.colorPaletteCode,
                                            trimList: item.trimList
                                        }))}
                                    />
                                }

                    <div className="carPrice-wrap">
                        <span className="carPrice-color">{form.color ? `${entities.colors[form.color].colorName}` : ''} <span className="carPrice-stock">({stock} in stock)</span></span>
                    </div>


                    </div>
                    <div className='cardetailArtical'>
                        <div className="carInfo-title">TECHNICAL DATA</div>
                        {
                            form.carModel && form.color && form.trim && form.package &&
                            <VehicleSpecs fields={fields} />
                        }
                        <p className="optinNoticeLink" onClick={(e) => this.handleClick(e, pkg.pdf)}>
                            Please click here for detailed specifications.
                        </p>
                    </div>
                </div>
                    <div id="right-info" className="rightSide">
                            <div className='cardetailArtical rightFullScreen'>

                            <div className="calc-container">
                                <div className="calc-title">Financial Calculator</div>
                                <div className="calc-wrap">
                                    <div className="calc-label">Price</div>
                                    <div className="calc-input">{currencyHelper.formatCurrencyJP(state.price)}</div>
                                </div>
                                <div className="calc-wrap">
                                    <div className="calc-label">Promotional Code</div>
                                    { this.state.promoValid ? <div className="calc-check"><span className="calc-checkmark"></span></div>: '' }
                                    <input className="calc-input calc-promo" placeholder="-" 
                                    onKeyPress={e => e.key === 'Enter' && this.handlePromo()} 
                                    onChange={this.handleChange}  
                                    maxLength={8}
                                    onBlur={this.handlePromo} 
                                    name="promo" 
                                    value={this.state.promo} /> <span className="calc-promodesc">{this.state.promoPriceDesc}</span> <span className="calc-desc">{this.state.promoDesc}</span>
                                </div>
                                <div className="calc-wrap">
                                    <div className="calc-label">Nett Price</div>
                                    <div className="calc-input">{state.netPrice ? currencyHelper.formatCurrencyJP(state.netPrice) : ''}</div>
                                </div>
                                <div className="calc-wrap left-half">
                                    <div className="calc-label">Select Tenure</div>
                                    <select value={this.state.tenure} className="calc-select" onChange={this.handleChange} name="tenure">
                                        <option value={1}>1 year</option>
                                        <option value={2}>2 years</option>
                                        <option value={3}>3 years</option>
                                        <option value={4}>4 years</option>
                                        <option value={5}>5 years</option>
                                        <option value={6}>6 years</option>
                                        <option value={7}>7 years</option>
                                    </select>
                                </div>
                                <div className="calc-wrap right-half">
                                    <div className="calc-label">Enter Loan Amount</div>
                                    <span className="calc-red">$<input type="" className="calc-input loan"
                                    onKeyPress={e => e.key === 'Enter' && this.blurLoan(e)}  onChange={this.handleChange} onFocus={() => this.toggleInput(false)} onBlur={(e) => { this.blurLoan(e) } } name="loanAmount" value={this.state.loanAmount} /></span> <span className="calc-grey">({state.loanPercent && (state.loanPercent !== NaN) && state.loanAmount ? parseInt(state.loanPercent).toFixed(0) : ''}%)</span>
                                </div>
                                <div className="calc-wrap">
                                    <div className="calc-label">Estimated Monthly Payment</div>
                                    <div className="calc-input month">{state.monthlyPayment ? currencyHelper.formatCurrencyJP(state.monthlyPayment) : ''}</div> <span className="calc-grey">({state.interestRate}%)</span>
                                </div>
                            </div>

                            <div className="calc-coe">
                                Price stated above { pkg.coeInclusive ? 'includes' : 'excludes' } COE, and is after in-house finance rebate and insurance subsidy.
                            </div>
                            {/* <div className="calc-minmax">
                                Minimum Loan Amount: {state.minLoan ? currencyHelper.formatCurrencyJP(state.minLoan) : ''} <br />
                                Maximum Loan Amount: {state.maxLoan ? currencyHelper.formatCurrencyJP(state.maxLoan)  : ''}
                            </div> */}
                            <div className="calc-error">
                                {this.state.loanError} 
                            </div>
                            <div className="calc-error">
                                {
                                 state.promo && !state.promoValid ? 'Promo Code is not valid.' : ''
                                }
                            </div>
                            {/* <div className="calc-error">
                                {
                                 state.loanAmount && (parseInt(state.loanAmount.toString().replace(',', '')) > state.maxLoan || parseInt(state.loanAmount.toString().replace(',', '')) < state.minLoan) ? 'Loan Amount must be between ' + currencyHelper.formatCurrencyJP(state.minLoan) + " and " + currencyHelper.formatCurrencyJP(state.maxLoan) + "."  : ''
                                }
                            </div> */}
                            </div>

                                        <button className="carInfo-buy" 
                                        onClick={this.state.loanError || (state.promo && !state.promoValid)  ? null : () => this.handleForm(
                                            state.monthlyPayment,
                                            state.interestRate,
                                            state.loanPercentOMV,
                                            state.netPrice,
                                            pkg.techSpec1,
                                            pkg.techSpec2,
                                            pkg.techSpec3,
                                            pkg.techSpec4,
                                            entities.colors[form.color].colorPaletteCode,
                                            entities.colors[form.color].colorName,
                                            stock,
                                            pkg.pdf,
                                            src,
                                            pkg.modelClassLabel,
                                            pkg.carModelName,
                                            pkg.id,
                                            pkg.carModelId,
                                            pkg.color,
                                            state.loanPercent
                                        )}
                                        disabled={this.state.loanError || (state.promo && !state.promoValid)}
                                        >NEXT</button>
                            <div className="priceCondition">
                                {pkg.priceCondition ? " " + pkg.priceCondition.replace(/<BR>/g, '\n') : ''}
                            </div>
                        </div>

            </div>
            {this.state.showPopup ?
                <ConfirmationPopup
                    text={<div className="confirmTxt">
                        <p> {this.state.popupTxt}</p>
                        <button onClick={this.handlePopup} className="btn btn-primary popbtn"> OK </button>

                    </div>}
                />
                : null
            }
        </div>
    }
}

let StyledConfigurator = styled(Configurator)`
position: relative;
width: 100%;
display: block;

.loanFormat {
    vertical-align: middle;
    width: 75px;
}
.calc-title {
    font-size: 23px;
    font-weight: bold;
    letter-spacing: 3.45px;
    text-transform: uppercase;
    margin-bottom: 20px;
    text-align: center;
}

.calc-error {
    color: #890000;
    margin-bottom: 10px;
    text-align: center;
    font-weight: bold;
}

.calc-check {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1px solid #6D934B;
    vertical-align: -2px;
    margin-right: 2px;
    position: relative;
}
.calc-checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 16px;
    width: 16px;
    border: 1px solid #6D934B;
  }
  .calc-checkmark {
    border: none;
  }
  .calc-checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  .calc-checkmark:after {
    display: block;
  }
  
 .calc-checkmark:after {
    left: 6px;
    top: 2px;
    width: 3px;
    height: 8px;
    border: solid #6D934B;
    border-width: 0 1px 1px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
.calc-promo {
    color: #890000;
    font-size: 17px;
    text-align: center;
    width: 115px;

    &::placeholder {
        color: #890000;
    }
}

.calc-desc {
    color: #666666;
    font-size: 15px;
    display: block;
}

.calc-promodesc {
    color: #666666;
    font-size: 15px;
}

.priceCondition {
    font-size: 15px;
    color: #666666;
    white-space: pre;
    padding-bottom: 50px;
    // padding-left: 10px;

    &::first-line {
        font-style: italic;
        font-weight: bold;
        // padding-left: 0;
    }

    @media (max-width: 420px) {
        margin-left: 15px;
        margin-right: 15px;
    }
}

.calc-wrap {
    border: 1px solid #BFBFBF;
    padding: 5px;
    text-align: center;
    margin-bottom: 5px;
    min-height: 60px;

    @media (min-width: 421px) {
        &.left-half, &.right-half {
            width: 49.5%;
            display: inline-block;
        }
    }

    &.left-half {
        margin-right: 0.5%;
    }

    &.right-half {
        margin-left: 0.5%;
    }


    @media (max-width: 420px) {
        margin-left: 15px;
        margin-right: 15px;
        height: auto;
        min-height: 60px;

        &.left-half, &.right-half {
            // width: calc(49.5% - 15px);
            display: block;
            vertical-align: middle;
            margin-left: 15px;
            margin-right: 15px;
        }
    
        // &.left-half {
        //     margin-right: 0.5%;
        //     margin-left: 15px;
        // }
    
        // &.right-half {
        //     margin-left: 0.5%;
        //     margin-right: 15px;
        // }
    }


    .calc-label {
        color: #666666;
        font-weight: bold;
        letter-spacing: 1.95px;
        font-size: 13px;
        text-transform: uppercase;

        @media (max-width: 420px) {
            font-size: 12px;
        }
    }

    .calc-input {
        border: 0;
        outline: 0;

        &.loan {
            color: #890000;
            width: 70px;
        }

        &.month {
            width: 55px;
            margin: 0 auto;
            display: inline-block;
        }
    }

    .calc-select {
        appearance: none;
        border: 0;
        outline: 0;
        color: #890000;

        box-sizing: border-box;
        padding: 0 2rem;
        -webkit-appearance: none;
        -webkit-border-radius: 0px;

        background: url(${arrow}) no-repeat right #AAA;
        background-size: 20px 10px;
        -webkit-appearance: none;
        background-color: transparent;
        background-position-x: calc( 100% + 0px );
    }
}

.nav-container {
    text-align: center;
}

.calc-coe {
    font-style: italic;
    font-family: MazdaM;
    color: #999999;
    font-size: 15px;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
}

.calc-red {
    color: #890000;
}

.calc-grey {
    color: #AAA;
}

.calc-minmax {
    text-align: center;
    color: #AAA;
}

.nav-wrap {
    display: inline-block;
    margin-top: 19px;
    margin-bottom: 23px;
    
    .nav-txt {
        display: inline-block;
        margin-right: 30px;
        line-height: 20px;
        vertical-align: middle;
        color: #999999;
        font-size: 13px;

        @media (max-width: 420px) {
            margin-right: 15px;
            font-size: 11px;
        }
    }
    .nav-no {
        display: inline-block;
        font-size: 13px;
        color: #FFF;
        background-color: #999999;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 3px;
        line-height: 20px;
    }

    &.active .nav-txt {
        color: #101010;
    }

    &.active .nav-no {
        background-color: #890000;
    }
}

.carTitle-wrap {
    text-align: center;

    .carTitle-class {
        font-size: 25px;
        letter-spacing: 3.75px;
        font-weight: bold;

        @media (max-width: 1000px) {
            display: block;
        }
    }

    .carTitle-label {
        font-size: 15px;
        letter-spacing: 2.25px;
        font-weight: bold;
    }

    .carTitle-demo {
        font-size: 15px;
        letter-spacing: 2.25px;
        font-weight: bold;
    }
}

.wrapper{
    display: block;
    margin: 0 auto;
    height: 100%;
    @media (max-width: 1000px){
        max-width: 450px; 
        height: 100%;
    }

    &::after {
        content: " ";
        display: block; 
        height: 0; 
        clear: both;
    }
}

.topArtical{
    width: 450px;
    margin: 0 auto;
    @media (max-width: 450px){
        width: 100%;
        padding: 0px 20px;
    }
}
.carTitle {
    // font-family: CorporateACon,Helvetica,sans-serif;
    color: #333333;
    text-align: center;
    font-size: 1.5rem;
    position: relative;
}
.cardetailArtical{
    width: 50%;
    display: block;
    float: left;
    margin-bottom: 100px;
    @media (max-width: 1000px){
        width: 100%;
        margin-bottom: 0px;
    }
}
.cardetailArtical.rightFullScreen{
    float: right;
    margin-top: 10px;
}
.configurator__model_image {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}

.selectText {
    color:rgba(0,0,0,0.7);
    text-align: center;
    font-size: 27px;
    margin-bottom: 0px;
}
.Select-arrow {
    background-image: url(${Down_Arrow});
    background-size: 22.5px 11px;
    width: 22.5px;
    height: 11px;
    background-repeat: no-repeat;
}
.configurator__model-dropdown-container {

    max-width: 450px;
    margin: 0 auto;
    font-family: CorporateACon, Helvetica, sans-serif!important;
    text-align: center;
    display: block;
    height: auto;
    padding: 12px 12px;
    border-top: 1px solid #f3f3f3;
    border-bottom: 1px solid #f3f3f3;
    
    @media(min-width: 450px) {
      width: 450px;
    }
    
    @media(max-width: 450px) {
      width: 100%;
    }
}
.deliver {
    color: rgba(25,25,25,0.5);
    margin-bottom: 30px;
    text-align: center;
    text-transform: uppercase;
}
.installment-bar {

    height: 82.5px;
    padding-top: 12px;
    background-color: grey;
    position: fixed;
    z-index: 10;
    bottom: 0px;
    width: 100%;
    left: 0px;
    text-align: center;
  
  &, &__padding {
    width: 100%;
    height: 82.5px;
  }
  
  &__padding {
    margin-top: 20px;
  }

  .instalment{
    cursor: pointer;
    display: inline-block;
  }
  
  .instalment__amount-value {
      font-size: 25px;
      color: white;
      font-weight: lighter;
      cursor: pointer;
    }
    
    .instalment__amount {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
    }
  
    .instalment__arrow {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      height: 25px;
      width: auto;
      margin: 0 5px;
    }
  
    .instalment__month {
      font-size: 16px;
      color: #eee;
      font-weight: 100;
      cursor: pointer;
    }
  
    .instalment__check-eligibility {
      font-size: 20px;
      color: #ddd;
      font-weight: bold;
      text-align: right;
      cursor: pointer;
    }

}
.boldText {
    color: red;
    font-family: 'CorporateS-Bold';
}
.optinNoticeLink {
    cursor: pointer;
    font-size: 13px;
    color: #890000;
    text-align: left;
    letter-spacing: 1.95px;
    text-transform: uppercase;
    text-decoration: underline;

    @media (min-width: 1000px) {
        text-align: left;
    }

    @media (max-width: 420px) {
        padding-left: 15px;
        padding-right: 15px;
    }
}
.react-datepicker__month-container {
    width: 300px;
}
.react-datepicker__month, .react-datepicker__day-names, .react-datepicker__current-month, .react-datepicker__navigation--previous, .react-datepicker__navigation--next {
    display: block;
}
.carImg-info {
    font-family: MazdaM;
    color: #999999;
    font-size: 15px;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
}
.carPrice-wrap {
    text-align: center;
    margin-bottom: 30px;

    .carPrice-color {
        font-size: 14px;
    }

    .carPrice-stock {
        color: #890000;
    }
    .carPrice-price {
        font-size: 2.25rem;
        font-family: CorporateACon,Helvetica,sans-serif;
    }
    .carPrice-coe {
        font-size: 1.125rem;
        color: #666666;
    }
}
.imgCaption {
    font-size: 0.8rem;
    color: #BBB;
    margin-top: 10px;
}

.carGallery-wrap {
    .carGallery-image-wrap {
        display: inline-block;
        width: 30%;
        padding-left: 20px;
    }
    .carGallery-image {
        width: 100%;
        padding: 10px 0;
    }
    .carGallery-text {
        vertical-align: top;
        width: 70%;
        font-size: 1rem;
        display: inline-block;
        padding: 10px 20px;
    }
}
.carInfo-title {
    text-align: center;
    font-weight: bold;
    letter-spacing: 3.6px;
    font-size: 24px;
    color: #101010;
}
.carInfo-form {
    background-color: #F8F8F8;
    height: 100%;
}
.carInfo-input-label {
    color: #333333;
    font-size: 14px;
}
.carInfo-input-required {
    color: #ED0F0F;
}
.carInfo-input {
    border: 1px solid #D0D0D0;
    border-radius: 0;
    outline: 0;
    appearance: 0;
    box-sizing: border-box;
    padding: 10px;
    width: 100%;
    height: 48px;
    line-height: 48px;
    color: #333333;
    font-size: 16px;
    margin: 8px 0 2px 0;
    background: none;

    position: relative;

    &.error {
        border: 1px solid #a94442;
    }
}
.carInfo-input-wrap {
    padding: 15px;
    padding-bottom: 0;
    vertical-align: top;
}
.consent-link {
    text-decoration: none;
    color: #1DAEED;
}
.consent-check-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: inline-block;
  height: 25px;
  width: 25px;
  margin: 0 10px 0 0;
}

.consent-check-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.consent-checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  border: 1px solid #1DAEED;
}
.consent-check-container input:checked ~ .consent-checkmark {
  background-color: #2196F3;
  border: none;
}
.consent-checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.consent-check-container input:checked ~ .consent-checkmark:after {
  display: block;
}

.consent-check-container .consent-checkmark:after {
  left: 9px;
  top: 2px;
  width: 9px;
  height: 16px;
  border: solid white;
  border-width: 0 1px 1px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.consent-txt {
    display: inline;
}
.carInfo-buy {
    display: inline-block;
    background-color: #0F0F0F;
    color: #FFFFFF;
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 1.95px;
    border-radius: 0;
    text-align: center;
    line-height: 60px;
    height: 60px;
    width: 100%;
    margin-bottom: 20px;
    cursor: pointer;

    @media (max-width: 420px) {
        margin-left: 15px;
        margin-right: 15px;
        width: calc(100% - 30px);
    }
}

.carInfo-buy:disabled, .carInfo-enquire:disabled {
    opacity: 0.5;
    cursor: initial;
}
.carInfo-enquire {
    display: inline-block;
    background-color: #000000;
    color: #FFF;
    font-size: 18px;
    border-radius: 0;
    text-align: center;
    line-height: 48px;
    height: 48px;
    width: 100%;
    margin-bottom: 20px;
    cursor: pointer;
}
@media (min-width: 1000px) {
    .topArtical {
        width: 100%;
    }
    .configurator__model_image {
        // width: 690px !important;
    }
    .leftSide {
        padding-left: 135px;
        padding-right: 10px;
        width: 50%;
        display: inline-block;
        float: left;
        // overflow-y: auto;
        // height: calc(90vh - 86px);
        // overflow-x: hidden;
    }
    .rightSide {
        padding-right: 135px;
        width: 50%;
        display: inline-block;
        float: right;
        // overflow-y: auto;
        // height: calc(90vh - 86px);
        padding-left: 15px;
    }
    .cardetailArtical {
        width: 100%;
        float: none;
        margin-bottom: 0;
    }
    .carGallery-feature {
        width: 33%;
        display: inline-block;
        text-align: center;
    }
    .carGallery-image-wrap {
        padding-left: 0 !important;
        width: 100% !important;
    }
    .carGallery-text {
        text-align: left;
        width: 100% !important;
    }
    .carInfo-title {
        padding-left: 0;
    }
    .carInfo-enquire {
        margin-left: 30px;
        margin-right: 14px;
    }
    .carGallery-image {
        width: 95% !important;
    }
    .carGallery-text {
        padding-left: 6px !important;
    }
    .carInfo-input-wrap.half {
        width: 50%;
        display: inline-block;
    }
}

.carInfo-placeholder::placeholder {
    font-size: 12px;
}

.carInfo-error {
    color: #a94442;
    display: inline-block;

    &.consent {
        font-weight: bold;
        padding-left: 15px;
    }
}

.carInfo-error-placeholder {
    // height: 1.5rem;
}

.nav-back-button {
    cursor: pointer;
    line-height: 32px !important;
    margin-bottom: 10px;

    @media (max-width: 1000px) {
        padding-left: 15px;
    }
  }    
  
  .nav-back-button img {
    position: relative;
    top: -2px;
  }

  .nav-back-txt {
    padding: 0 7.125px;
    line-height: 30px;
    display: inline-block;
    color: rgba(0,0,0,0.3);
  }
// @media (min-width: 1000px) and (max-width: 1500px) {
//     .leftSide {
//         // margin-top: -20px;
//     }
//     .configurator__model_image {
//         max-height: 150px;
//     }
//     .carPrice-price {
//         font-size: 1.2rem !important;
//     }
//     .modelName {
//         font-size: 1.2rem !important;
//     }
// }
`;

export default withRouter(StyledConfigurator)


// WEBPACK FOOTER //
// ./src/components/configurator/Configurator.js